var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("打开运费费率表")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }